import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import useSWR from 'swr'

import { Loading } from '@/components/Loading'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { DocumentForm } from '@/forms/DocumentForm'
import { Settings } from '@/interfaces/Settings'

export default function OrderEditPage() {
  const { id } = useParams()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'order',
  })
  const { data: documentData, isLoading: ordersLoading } = useSWR(
    id && `/api/v2/orders/${id}`,
    apiFetcher,
  )
  const { data: settings, isLoading } = useSWR<Settings>(`/api/v2/settings`, apiFetcher)
  const title = `${t('edit.title')} ${id}`

  useSetPageHeader({
    breadcrumbs: [
      {
        href: '/orders',
        children: t('list.title'),
      },
      {
        href: `/order/${id}`,
        children: id as string,
      },
    ],
  })

  return (
    <>
      <title>{title}</title>

      {(ordersLoading || isLoading) && <Loading />}

      {documentData && (
        <DocumentForm
          type="order"
          documentData={documentData}
          settings={settings!}
        />
      )}
    </>
  )
}
